import { Link } from "react-router-dom";
import {
  EMAIL,
  SiteFooter,
  SiteNav,
  usePageMeta,
  useSiteStyles,
} from "./SiteLayout";

export default function Privacidade() {
  useSiteStyles();
  usePageMeta(
    "Política de Privacidade | Solfac",
    "Saiba como a Solution Factory (Solfac) coleta, utiliza, armazena e protege os dados acessados pelo aplicativo Solfac Social nas plataformas Instagram e Facebook, conforme a LGPD.",
  );

  return (
    <div style={{ background: "#050505", minHeight: "100vh" }}>
      <SiteNav />

      <main className="sf-legal">
        <div className="sf-section-tag">Documento legal</div>
        <h1 className="sf-section-title">
          POLÍTICA DE <span>PRIVACIDADE</span>
        </h1>
        <p className="sf-legal-updated">
          Última atualização: 22 de outubro de 2026
        </p>

        <p>
          Esta Política de Privacidade descreve como a Solution Factory trata
          os dados acessados por meio do aplicativo <strong>Solfac Social</strong>,
          que se conecta à API do Instagram, às Páginas do Facebook e à API de
          Marketing da Meta para prestar serviços de marketing digital aos
          nossos clientes.
        </p>

        <h2>1. Quem somos</h2>
        <p>
          A Solution Factory (Solfac) é uma agência de marketing digital e
          comunicação B2B, sediada em Juiz de Fora, MG. Somos a responsável
          pelo tratamento dos dados descritos nesta política. Para qualquer
          assunto relacionado à privacidade, entre em contato pelo e-mail{" "}
          <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
        </p>

        <h2>2. Dados que acessamos</h2>
        <p>
          O aplicativo só acessa dados depois que o cliente autoriza a conexão
          ao fazer login com sua conta do Instagram ou do Facebook. Conforme as
          permissões concedidas, podemos acessar:
        </p>
        <ul>
          <li>Nome de usuário e ID da conta;</li>
          <li>Foto e dados do perfil profissional;</li>
          <li>Mídias publicadas na conta;</li>
          <li>Comentários feitos nas publicações;</li>
          <li>Mensagens recebidas na conta;</li>
          <li>Métricas e insights de desempenho;</li>
          <li>Dados de Páginas do Facebook administradas pelo cliente;</li>
          <li>Dados de contas de anúncios vinculadas.</li>
        </ul>
        <p>
          Não acessamos senhas. A autenticação é feita diretamente pela Meta,
          que nos fornece apenas um token de acesso com as permissões que o
          cliente aprovou.
        </p>

        <h2>3. Como utilizamos os dados</h2>
        <p>
          Os dados são utilizados exclusivamente para prestar os serviços
          contratados, em nome do cliente:
        </p>
        <ul>
          <li>Publicar e agendar conteúdos no Instagram e no Facebook;</li>
          <li>Responder comentários, mensagens e outras interações;</li>
          <li>Gerar relatórios de desempenho das contas e publicações;</li>
          <li>Criar, acompanhar e otimizar campanhas de anúncios.</li>
        </ul>

        <h2>4. Compartilhamento de dados</h2>
        <p>
          Não vendemos, alugamos nem cedemos dados a terceiros. Os dados são
          compartilhados apenas com provedores de infraestrutura necessários à
          operação do serviço, como hospedagem e armazenamento em nuvem, que
          atuam sob obrigações de confidencialidade e segurança.
        </p>

        <h2>5. Armazenamento e segurança</h2>
        <p>
          Os tokens de acesso são armazenados de forma protegida, e o acesso
          aos dados é restrito aos profissionais da equipe que precisam deles
          para executar o serviço. Mantemos os dados apenas pelo tempo em que
          durar a relação contratual com o cliente. Ao final dessa relação, ou
          mediante solicitação, os dados são excluídos.
        </p>

        <h2>6. Seus direitos</h2>
        <p>
          Conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você
          pode, a qualquer momento:
        </p>
        <ul>
          <li>Confirmar se tratamos seus dados e acessá-los;</li>
          <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
          <li>Solicitar a exclusão dos seus dados;</li>
          <li>Revogar o consentimento dado para o tratamento.</li>
        </ul>
        <p>
          Para exercer esses direitos, envie um e-mail para{" "}
          <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. Para pedidos de exclusão,
          siga as orientações da página{" "}
          <Link to="/exclusao-de-dados">Instruções de Exclusão de Dados</Link>.
        </p>

        <h2>7. Como revogar o acesso do aplicativo</h2>
        <p>
          Você pode remover o acesso do Solfac Social diretamente nas
          configurações das plataformas:
        </p>
        <ul>
          <li>
            <strong>Instagram:</strong> acesse Configurações e depois Apps e
            sites, selecione o Solfac Social e remova o acesso.
          </li>
          <li>
            <strong>Facebook:</strong> acesse Configurações e depois Apps e
            sites ou Integrações empresariais, selecione o Solfac Social e
            remova o acesso.
          </li>
        </ul>
        <p>
          Depois da revogação, o aplicativo deixa de acessar novos dados da
          conta.
        </p>

        <h2>8. Alterações desta política</h2>
        <p>
          Esta política pode ser atualizada para refletir mudanças nos nossos
          serviços ou na legislação. A data da versão vigente fica sempre
          indicada no topo desta página.
        </p>

        <h2>9. Contato</h2>
        <p>
          Em caso de dúvidas sobre esta política ou sobre o tratamento dos seus
          dados, fale com a Solution Factory pelo e-mail{" "}
          <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
        </p>
      </main>

      <SiteFooter />
    </div>
  );
}
